module.exports = "/_next/static/images/465ae08fb05a20f5b198ed21fef27a92-valor-logo.png";